"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoPurchaseNecessaryData = void 0;
const validation_1 = __importDefault(require("../../config/validation"));
class NoPurchaseNecessaryData {
    static maxCharacterLimit(value, limit = validation_1.default.maxNameLength) {
        return value !== null && value.length > 0 && value.length <= limit;
    }
    constructor(data = null) {
        this.firstName = '';
        this.lastName = '';
        this.dateOfBirth = undefined;
        this.email = '';
        this.address = null;
        this.phone = '';
        this.recaptcha = '';
        this.getPostRequest = (promotionId, lotteryId) => (Object.assign(Object.assign({ email: this.email, firstName: this.firstName, lastName: this.lastName, dateOfBirth: this.dateOfBirth }, this.address), { phone: this.phone, lotteryId,
            promotionId, recaptcha: this.recaptcha }));
        if (data !== null) {
            this.email = data.email;
            this.firstName = data.firstName;
            this.lastName = data.lastName;
            this.dateOfBirth = data.dateOfBirth;
            this.address = data.address;
            this.phone = data.phone.replace(/\D+/g, '');
            this.recaptcha = data.recaptcha;
        }
    }
    get isValidEmail() {
        if (this.email === null) {
            return false;
        }
        return (this.email.length <= 100 && validation_1.default.emailValidationRegex.test(this.email.toLowerCase()));
    }
    get isValidFirstName() {
        if (this.firstName === null) {
            return false;
        }
        return (NoPurchaseNecessaryData.maxCharacterLimit(this.firstName) &&
            validation_1.default.stringAsSpace.test(this.firstName));
    }
    get isValidLastName() {
        if (this.lastName === null) {
            return false;
        }
        return (NoPurchaseNecessaryData.maxCharacterLimit(this.lastName) &&
            validation_1.default.stringAsSpace.test(this.lastName));
    }
    get isValidPhoneNumber() {
        if (!this.phone || this.phone === '') {
            return true;
        }
        return validation_1.default.phoneValidationRegex.test(this.phone);
    }
    get isValidAddress() {
        if (!this.address ||
            (this.address.address1.length === 0 &&
                this.address.city.length === 0 &&
                this.address.zipCode.length === 0 &&
                this.address.country.length === 0 &&
                this.address.state.length === 0)) {
            return true;
        }
        return (validation_1.default.stringAsSpace.test(this.address.address1) &&
            this.address.address1.length > 0 &&
            this.address.city.length > 0 &&
            validation_1.default.stringAsSpace.test(this.address.zipCode) &&
            this.address.zipCode.length > 0 &&
            this.address.country.length > 0 &&
            this.address.state.length > 0);
    }
    get nonEmpty() {
        return !(!this.address &&
            !this.phone &&
            !this.firstName &&
            !this.lastName &&
            !this.dateOfBirth &&
            !this.email);
    }
    get isValidDateOfBirth() {
        return this.dateOfBirth !== undefined;
    }
    get isValidData() {
        return (this.isValidAddress &&
            this.isValidFirstName &&
            this.isValidLastName &&
            this.isValidEmail &&
            this.isValidDateOfBirth &&
            this.isValidPhoneNumber);
    }
}
exports.NoPurchaseNecessaryData = NoPurchaseNecessaryData;
//# sourceMappingURL=NoPurchaseNecessaryData.js.map